export default __webpack_public_path__ + "static/media/cvideo.fc6b8291.png";